import type { ReactNode } from 'react';

export const symbol_splitscreen_portrait: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M310-200h340q12.75 0 21.38-8.63Q680-217.25 680-230v-190q0-12.75-8.62-21.38Q662.75-450 650-450H310q-12.75 0-21.37 8.62Q280-432.75 280-420v190q0 12.75 8.63 21.37Q297.25-200 310-200Zm0-310h340q12.75 0 21.38-8.63Q680-527.25 680-540v-190q0-12.75-8.62-21.38Q662.75-760 650-760H310q-12.75 0-21.37 8.62Q280-742.75 280-730v190q0 12.75 8.63 21.37Q297.25-510 310-510Zm490 370q0 24-18 42t-42 18H220q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520q24 0 42 18t18 42v680Zm-60 0v-680H220v680h520Zm0-680H220h520Z"
		/>
	</svg>
);
